<template>
  <div class="tw-flex tw-items-center tw-h-46px">
    <div
      id="connector1"
      class="tw-w-1 tw-transition tw-duration-500 tw-mb-1 tw-ease-in-out tw-border tw-h-1 tw-rounded-l"
      :class="
        step > 0 ? 'tw-border-green-700 tw-bg-green-700' : 'tw-border-gray-1000 tw-bg-gray-1000'
      "
    ></div>
    <div
      id="No"
      class="tw-flex tw-flex-col tw-z-10 tw-items-center tw-justify-center tw-pt-3.5 tw-w-5 tw-h-46px tw-text-center "
      @click="setStep(0)"
    >
      <div v-if="step === 0">
        <div
          class="tw-flex tw-items-center tw-w-5 tw-h-5 tw-justify-center tw-transition tw-duration-500 tw-ease-in-out tw-border-2 tw-bg-green-700 tw-border-green-700 tw-rounded-full"
        ></div>
        <label
          class="tw-text-xs tw-pt-1 tw-font-normal tw-text-black tw-h-18px tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          No
        </label>
      </div>
      <div v-else>
        <div
          class="tw-flex tw-items-center tw-w-29px tw-h-1 tw-justify-center tw-p-0 tw-transition tw-duration-500 tw-ease-in-out tw-border-2 "
          :class="
            step > 0
              ? 'tw-bg-green-700 tw-border-green-700'
              : ' tw-bg-gray-1000 tw-border-gray-1000'
          "
        ></div>

        <label
          class="tw-text-xs tw-font-normal tw-text-black tw-h-18px tw-pt-3 tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          No
        </label>
      </div>
    </div>
    <div
      id="connector2"
      class="tw-flex-1 tw-transition tw-duration-500 tw-mb-1 tw-ease-in-out tw-border tw-h-1 tw-rounded-l "
      :class="
        step >= 1 ? 'tw-border-green-700 tw-bg-green-700' : 'tw-border-gray-1000 tw-bg-gray-1000'
      "
    ></div>
    <div
      id="Different"
      class="tw-flex tw-z-10 tw-flex-col tw-items-center tw-justify-center tw-pt-3.5 tw-w-5 tw-h-46px tw-text-center "
      @click="setStep(1)"
    >
      <div v-if="step === 1">
        <div
          class="tw-flex tw-items-center tw-w-5 tw-m-auto tw-h-5 tw-justify-center tw-transition tw-duration-500 tw-ease-in-out tw-border-2 tw-bg-green-700 tw-border-green-700 tw-rounded-full"
        ></div>
        <label
          class="tw-text-xs tw-pt-1 tw-text-center tw-font-normal tw-text-black tw-h-18px tw-leading-10px tw-flex tw-flex-col"
        >
          Different
        </label>
      </div>
      <div v-else>
        <div
          class="tw-flex tw-items-center tw-w-9 tw-h-1 tw-justify-center tw-p-0 tw-transition tw-duration-500 tw-ease-in-out tw-border-2 "
          :class="
            step >= 1
              ? 'tw-bg-green-700 tw-border-green-700'
              : ' tw-bg-gray-1000 tw-border-gray-1000'
          "
        ></div>

        <label
          class="tw-text-xs tw-font-normal tw-text-black tw-h-18px tw-pt-3 tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          Different
        </label>
      </div>
    </div>
    <div
      id="connector3"
      class="tw-flex-1 tw-transition tw-duration-500 tw-ease-in-out tw-mb-1 tw-border tw-h-1 tw-rounded-l "
      :class="
        step >= 2 ? 'tw-border-green-700 tw-bg-green-700' : 'tw-border-gray-1000 tw-bg-gray-1000'
      "
    ></div>
    <div
      id="Unsure"
      class="tw-flex tw-z-10 tw-flex-col tw-items-center tw-justify-center tw-pt-3.5 tw-w-5 tw-h-46px tw-text-center "
      @click="setStep(2)"
    >
      <div v-if="step === 2">
        <div
          class="tw-flex tw-items-center tw-w-5 tw-m-auto tw-h-5 tw-justify-center tw-transition tw-duration-500 tw-ease-in-out tw-border-2 tw-bg-green-700 tw-border-green-700 tw-rounded-full"
        ></div>

        <label
          class="tw-text-xs tw-pt-1 tw-font-normal tw-text-black tw-h-18px tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          Unsure
        </label>
      </div>
      <div v-else>
        <div
          class="tw-flex tw-items-center tw-w-8 tw-h-1 tw-justify-center tw-p-0 tw-transition tw-duration-500 tw-ease-in-out tw-border-2 "
          :class="
            step >= 2
              ? 'tw-bg-green-700 tw-border-green-700'
              : ' tw-bg-gray-1000 tw-border-gray-1000'
          "
        ></div>

        <label
          class="tw-text-xs tw-font-normal tw-text-black tw-h-18px tw-pt-3 tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          Unsure
        </label>
      </div>
    </div>

    <div
      id="connector4"
      class="tw-flex-1 tw-transition tw-duration-500 tw-mb-1 tw-ease-in-out tw-border tw-h-1 tw-rounded-l "
      :class="
        step >= 3 ? 'tw-border-green-700 tw-bg-green-700' : 'tw-border-gray-1000 tw-bg-gray-1000'
      "
    ></div>
    <div
      id="NA"
      class="tw-flex tw-z-10 tw-flex-col tw-items-center tw-justify-center tw-pt-3.5 tw-w-5 tw-h-46px tw-text-center "
      @click="setStep(3)"
    >
      <div v-if="step === 3">
        <div
          class="tw-flex tw-items-center tw-w-5 tw-h-5 tw-justify-center tw-transition tw-duration-500 tw-ease-in-out tw-border-2 tw-bg-green-700 tw-border-green-700 tw-rounded-full"
        ></div>
        <label
          class="tw-text-xs tw-pt-1 tw-font-normal tw-text-black tw-h-18px tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          NA
        </label>
      </div>
      <div v-else>
        <div
          class="tw-flex tw-items-center tw-w-29px tw-h-1 tw-justify-center tw-p-0 tw-transition tw-duration-500 tw-ease-in-out tw-border-2 "
          :class="
            step >= 3
              ? 'tw-bg-green-700 tw-border-green-700'
              : ' tw-bg-gray-1000 tw-border-gray-1000'
          "
        ></div>

        <label
          class="tw-text-xs tw-font-normal tw-text-black tw-h-18px tw-pt-3 tw-text-center tw-leading-10px tw-flex tw-flex-col"
        >
          NA
        </label>
      </div>
    </div>
    <div
      id="connector5"
      class="tw-w-1 tw-transition tw-duration-500 tw-mb-1 tw-ease-in-out tw-border tw-h-1 tw-rounded-r "
      :class="
        step >= 3 ? 'tw-border-green-700 tw-bg-green-700' : 'tw-border-gray-1000 tw-bg-gray-1000'
      "
    ></div>
  </div>
</template>

<script>
export default {
  name: "SummaryRecordSlidder",
  props: ["stepProp"],
  data() {
    return {
      step: 0,
      textColor: ""
    };
  },
  mounted() {
    switch (this.stepProp) {
      case "No different":
        this.step = 0;
        break;
      case "Very different":
        this.step = 1;
        break;
      case "Unsure":
        this.step = 2;
        break;
      case "Not applicable":
        this.step = 3;
        break;
      default:
        this.step = 0;
        break;
    }
  },
  methods: {
    setConnectorColor() {
      if (step === 1) {
        this.connector1 = "tw-border-green-700";
        this.connector2 = "tw-border-green-700";
      } else if (step === 2) {
        this.connector1 = "tw-border-green-700";
        this.connector2 = "tw-border-green-700";
        this.connector3 = "tw-border-green-700";
      } else if (step === 2) {
        this.connector1 = "tw-border-green-700";
        this.connector2 = "tw-border-green-700";
        this.connector3 = "tw-border-green-700";
        this.connector4 = "tw-border-green-700";
        this.connector5 = "tw-border-green-700";
      }
    },
    setStep(stepValue) {
      this.step = stepValue;
      if (this.step > 0) {
        this.textColor = "tw-border-green-700 tw-bg-green-700";
      }
      this.$emit("step", this.step);
    }
  }
};
</script>

<style scoped></style>
